import session from './session';
import { initRoom } from '../io';
import jsonParse from './json-parse';

import { createUserBot } from '../reducers/user/resources';
import { checkIfNewUser } from '../utils/user';
import { stashPostLoginRedirect } from './post-login-redirect';
import config from '../config';

export const isAuthenticated = props => {
	const { history, match, location } = props;

	if (session.get('token')) {
		const user = jsonParse(session.get('userData'));
		const fromEmailParam = session.getURLParam('fromemail')
		const routeParam = session.getURLParam('route')
		const isAdmin = user.role === config.userRoles.ghAdmin;
		
		initRoom(user.id);

		if (match.path !== '/login') {
			(async () => {
				const userData = await checkIfNewUser();
				if(!userData){
					stashPostLoginRedirect(location);
					history.replace({ pathname: '/login' });
				}

				const { isNewUser } = userData;

				if (isNewUser) {
					history.replace({ pathname: '/account-setup' });
				}
			})();
		} else if (!isAdmin && fromEmailParam) {
			history.replace({ pathname: `/${routeParam}` });
		} else {
			history.replace({ pathname: '/inbox' });
		}
		return true;
	}

	if (match.path !== '/login') {
		// Remember the deep link (e.g. the extension's "connect your calendar"
		// hand-off) so the login can return the user to it.
		stashPostLoginRedirect(location);
		history.replace({ pathname: '/login' });
	}
	return false;
};
